import React from "react";
import { numberWithSpaces } from "../utils";
import { resultsType } from "../../common/types/search/results";

interface SearchResultsPreviewProps {
	results: resultsType;
	loading?: boolean;
	error?: boolean;
	label?: string;
}

export function SearchResultsPreview({
	results,
	loading,
	error,
	label = "Results",
}: SearchResultsPreviewProps) {
	const { counts, carriers, aircraft } = results;

	let content: React.ReactNode;
	if (loading) {
		content = "Loading...";
	} else if (error || counts === undefined) {
		content = null;
	} else if (carriers !== undefined) {
		content = `${numberWithSpaces(counts)} aircraft and ${numberWithSpaces(carriers)} operator(s)`;
	} else if (aircraft !== undefined) {
		content = `${numberWithSpaces(counts)} records and ${numberWithSpaces(aircraft)} aircraft`;
	} else {
		content = `${numberWithSpaces(counts)} ${label}`;
	}

	return content && <span className="search-results-count">{content}</span>;
}
